'use client'

import { timezoneDateTime } from '@/helpers/datetime'
import { getMainSession } from '@/helpers/events'
import dayjs from '@/lib/dayjs'
import Link from 'next/link'

import CalendarEventCard from './calendar-event-card'
import CalendarEventPlaceholder from './calendar-event-placeholder'

export default function DriverCalendarMonth({
  events,
  monthIndex,
  session,
  month,
}) {
  let eventsInMonth = []
  if (events && events?.length > 0) {
    eventsInMonth = events.filter((event) => {
      let mainSession = getMainSession({ event: event })
      if (!mainSession) return

      let sessionTime = timezoneDateTime({
        datetime: mainSession.targetDateTime,
        timezone: mainSession.targetTimezone,
        format: false,
      })

      return sessionTime.isBetween(month, month.add(1, 'month'))
    })
  }

  function getEventsForRange(index) {
    return eventsInMonth.filter((event) =>
      timezoneDateTime({
        datetime: getMainSession({ event: event }).targetDateTime,
        timezone: getMainSession({ event: event }).targetTimezone,
        format: false,
      }).isBetween(
        month.add(index * 7, 'day'),
        month.add((index + 1) * 7, 'day'),
      ),
    )
  }

  function getWeekBeginningsInMonth() {
    const results = []
    //const month = dayjs().month(monthIndex).date(1)
    for (let weekIndex = 0; weekIndex <= 6; weekIndex++) {
      const weekBeginningDate = month.add(7 * weekIndex, 'days')
      if (weekBeginningDate.month() === monthIndex) {
        results.push(weekBeginningDate)
      }
    }
    return results
  }

  return (
    <div className="relative h-full">
      {eventsInMonth.length > 0 && <div className="divider m-2"></div>}
      {eventsInMonth.length == 0 ? (
        <div className="my-6 flex flex-col items-baseline justify-between gap-4 rounded-sm border border-neutral-blue-700 bg-neutral-blue-700 px-8 py-10">
          <h5 className="font-inter text-h-6 font-medium text-shades-0 lg:text-h-5">
            {month.format('dddd DD MMMM')} -{' '}
            {month.add(1, 'month').format('dddd DD MMMM')}
          </h5>
          <p className="font-inter text-p-3 font-semibold text-neutral-blue-500">
            No events this month.{' '}
          </p>
          <Link
            href="/sim-racing-events"
            className="ml-[5px] hidden cursor-pointer font-inter font-normal text-shades-0 underline underline-offset-2 lg:inline-block"
          >
            Find an event
          </Link>
        </div>
      ) : (
        <div className="relative grid w-full grid-cols-1">
          <div className="col-start-1 flex h-auto w-full flex-col gap-5">
            {getWeekBeginningsInMonth().map((weekBeginningDate, index) => (
              <div key={`event-cards-week-${index}`}>
                <h3 className="my-5 rounded font-inter text-lg font-bold uppercase text-neutral-blue-400">
                  <span className="mr-[10px] text-shades-0">{`Week ${index + 1} `}</span>
                  {`${weekBeginningDate.format('DD MMM')} - ${weekBeginningDate
                    .add(6, 'day')
                    .format('DD MMM')}`}
                </h3>
                <div className="flex flex-col gap-5">
                  {getEventsForRange(index).length === 0 ? (
                    <CalendarEventPlaceholder dayJsDate={dayjs()} isMonthView />
                  ) : (
                    getEventsForRange(index).map((event) => (
                      <CalendarEventCard
                        key={`event-card-${event.id}`}
                        event={event}
                        session={session}
                      />
                    ))
                  )}
                </div>
                <div id={`week-${index + 1}`} className="divider"></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
